import React from 'react'
import {Box, Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import {useMultiStyleConfig} from '@chakra-ui/react'
import {SmartSearchIcon} from '../../icons';

const CustomerSay = ({summary}) => {
    const styles = useMultiStyleConfig('CustomerSay')

    return (
        <Box {...styles.container}>
            <Flex {...styles.header}>
                <SmartSearchIcon {...styles.icon} />
                <Text as="h3" {...styles.title}>
                    <FormattedMessage
                        defaultMessage="Customers say"
                        id="pdp_reviews.review.generated.title"
                    />
                </Text>
            </Flex>
            <Text {...styles.summary}>
                {summary}
            </Text>
            <Text {...styles.note}>
                <FormattedMessage
                    defaultMessage="Summary generated from customer reviews"
                    id="pdp_reviews.review.generated.note"
                />
            </Text>
        </Box>
    )
}

CustomerSay.propTypes = {
    summary: PropTypes.string
}

export default CustomerSay
